import React from "react";
import { Box, Chip, Grid, Typography, useTheme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import {
  BuildRounded,
  FeedbackRounded,
  FileOpenRounded,
  PersonRounded,
  ThumbDownRounded,
  ThumbUpAltRounded,
  TrendingDownRounded,
  TrendingUpRounded,
} from "@mui/icons-material";

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: 16,
    backgroundColor: theme.palette.background.dark,
    borderRadius: 24,
  },
  card: {
    width: "100%",
    padding: 16,
    border: "1px solid #EFEBE9",
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    boxShadow: "0 0 12px 1px rgba(191, 191, 191, 0.16)",
  },
  negativeFeedbackChip: {
    display: "flex",
    alignItems: "center",
    padding: "3px 3px 3px 4px",
    borderRadius: 100,
    background: theme.palette.background.light,
    "& .MuiChip-root": {
      background: theme.palette.action.active,
      color: "white",
      fontWeight: 500,
    },
  },
}));

function Feedbacks({ feedbacks }) {
  const {
    total,
    positive,
    negative,
    ai_model_fix,
    doc_update,
    change: { total_pct, total_direction },
  } = feedbacks;
  const { classes } = useStyles();
  const theme = useTheme();
  return (
    <Box className={classes.container}>
      <Box px={2} mb={1.5}>
        <Typography variant="h6">Feedbacks</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#EFEBE9", borderRadius: 1 }}>
                <FeedbackRounded sx={{ fontSize: 16, color: "#795548" }} />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Feedbacks this week
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{total}</Typography>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  {total_direction === "increase" ? (
                    <TrendingUpRounded
                      sx={{ fontSize: 16, color: "#1B5E20" }}
                    />
                  ) : (
                    <TrendingDownRounded
                      sx={{ fontSize: 16, color: "#B71C1C" }}
                    />
                  )}
                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    sx={{
                      color:
                        total_direction === "increase" ? "#1B5E20" : "#B71C1C",
                    }}>
                    {Math.round(total_pct)}%
                  </Typography>
                </Box>
                <Typography variant="caption" color={"text.secondary"}>
                  WoW
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#EDE7F6", borderRadius: 1 }}>
                <ThumbUpAltRounded sx={{ fontSize: 16, color: "#6200EA" }} />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Positive Feedbacks
              </Typography>
            </Box>
            <Typography variant="h4">{positive}</Typography>
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#FFEBEE", borderRadius: 1 }}>
                <ThumbDownRounded sx={{ fontSize: 16, color: "#F44336" }} />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Negative Feedbacks
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{negative}</Typography>
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Box className={classes.negativeFeedbackChip}>
                  <FileOpenRounded
                    sx={{ fontSize: 18, color: theme.palette.action.active }}
                  />
                  <Box mr={"6px"} />
                  <Typography fontSize={13} color="text.secondary">
                    Doc Update
                  </Typography>
                  <Box mr={"6px"} />
                  <Chip size="small" label={doc_update} />
                </Box>
                <Box className={classes.negativeFeedbackChip}>
                  <BuildRounded
                    sx={{ fontSize: 18, color: theme.palette.action.active }}
                  />
                  <Box mr={"6px"} />
                  <Typography fontSize={13} color="text.secondary">
                    AI Fix
                  </Typography>
                  <Box mr={"6px"} />
                  <Chip size="small" label={ai_model_fix} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Feedbacks;
